module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Daisies Are Forever")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#cntvii",
      "id": "ctnvii"
    }
  }, [_vm._v("GLOSSARY OF FOREIGN WORDS")])]), _vm._v(" "), _c('p', {
    staticClass: "txline"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1b"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACHTUNG")]), _vm._v("—caution ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BAHNHOF")]), _vm._v("—railway station ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BITTE")]), _vm._v("—please ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DANKE")]), _vm._v("—thank you ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÜHRER")]), _vm._v("—the leader ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUTSCSCHES")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REUZ")]), _vm._v(" (DRK)—German Red Cross ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ESSEN KOMMEN")]), _vm._v("—come eat ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FLUCHT")]), _vm._v("—escape ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAU")]), _vm._v("—Mrs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRÄULEIN")]), _vm._v("—miss ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GUTEN MORGEN")]), _vm._v("—good morning ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HALTEN SIE")]), _vm._v("—stop ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HERR")]), _vm._v("—mister ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JA")]), _vm._v("—yes ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KINDER")]), _vm._v("—children ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KOMMEN")]), _vm._v("—come ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISTALLNACHT")]), _vm._v("—series of attacks against the Jews throughout Nazi Germany ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LUFTSCHUTZBUNKER")]), _vm._v("—air-raid shelter ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MUTTI")]), _vm._v("—mother ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEIN")]), _vm._v("—no ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("OMA")]), _vm._v("—grandma ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONKEL")]), _vm._v("—uncle ")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("OPA")]), _vm._v("—grandpa ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("REICHSMARK")]), _vm._v("("), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(")—German currency ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SCHNELL")]), _vm._v("—quickly ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TALINORGEL")]), _vm._v("—a rocket launcher nicknamed Stalin’s organ ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STRASSE")]), _vm._v("—road ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TANTE")]), _vm._v("—aunt ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TIEFFLIEGER")]), _vm._v("—low-flying German aircraft ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("VATER")]), _vm._v("—father ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLKSEMPFÄNGER")]), _vm._v("—people’s radio ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLKSSTURM")]), _vm._v("—German national militia ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UM")]), _vm._v(" Ö"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFENTLICHEN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UFTSCHUTZRAUM")]), _vm._v("—To Public Shelter ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1b"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USSIAN ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("Ти"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Φ")]), _vm._v(" к"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("APA")])]), _vm._v("нтин—Typhus Quarantine ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NYET")]), _vm._v("—no ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("URI")]), _vm._v("—watches ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 78
// module chunks = 0